import React, {PropTypes} from 'react';
import Error from '../../common/Error';
import EstablishmentForm from '../EstablishmentForm';

const EstablishmentManagementForm = ({
  form,
  removalForm,
  establishment,
  onSubmit,
  onCancel,
  onChange,
  onClick,
  submitStatus,
  errors,
  repeatedEstablishment,
  enteringNAICSCode,
  hideNAICSDropDown,
  onSelectNAICSOptions,
  NAICSOptions,
  onBlur,
  onFocus,
  naicsLoading
}) => {
  return (
    <div>
      <Error error={errors.establishment}/>
      <EstablishmentForm
        form={form}
        removalForm={removalForm}
        establishment={establishment}
        onSubmit={onSubmit}
        onCancel={onCancel}
        onChange={onChange}
        onClick={onClick}
        submitStatus={submitStatus}
        errors={errors}
        repeatedEstablishment={repeatedEstablishment}
        enteringNAICSCode={enteringNAICSCode}
        hideNAICSDropDown={hideNAICSDropDown}
        onSelectNAICSOptions={onSelectNAICSOptions}
        NAICSOptions={NAICSOptions}
        naicsLoading={naicsLoading}
        onBlur={onBlur}
        onFocus={onFocus}/>
    </div>
  );
};

EstablishmentManagementForm.propTypes = {
  form: PropTypes.object.isRequired,
  removalForm: PropTypes.object,
  establishment: PropTypes.object.isRequired,
  repeatedEstablishment: PropTypes.object,
  onSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onClick: PropTypes.func.isRequired,
  submitStatus: PropTypes.bool.isRequired,
  enteringNAICSCode: PropTypes.func.isRequired,
  hideNAICSDropDown: PropTypes.bool.isRequired,
  onSelectNAICSOptions: PropTypes.func.isRequired,
  naicsLoading: PropTypes.bool.isRequired,
  onBlur: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
  NAICSOptions: PropTypes.array,
  errors: PropTypes.object
};

export default EstablishmentManagementForm;



/** WEBPACK FOOTER **
 ** ./src/components/establishment/establishmentManagement/EstablishmentManagementForm.js
 **/